import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import ChatHistory from "../../components/chat-history/ChatHistory";
import "../../components/ChatApp.scss";
import "../../components/styles/reset.css";
import {
  Button,
  Divider,
  TextField,
  Autocomplete,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  InvokeGetServiceCall,
  InvokePostServiceCall,
  server_path,
} from "../../api/apiServices";
import { Markup } from "interweave";
import styled from "styled-components";
import "@splidejs/react-splide/css";
import { Spinner } from "react-bootstrap";
import { marked } from "marked";
import { Language_Models } from "../../constants/AppConstant";
import { ToastContainer, toast } from "react-toastify";
import ShareIcon from "@mui/icons-material/Share";

export const ConvoDiv = styled.div`
  border: 0.5px solid grey;
  padding: 10px;
  border-radius: 15px;
  margin: 2%;

  .copy-icon {
    float: right;
    cursor: pointer;
    display: none;
    opacity: 0.2;
    transition: opacity 0.3s;

    &:hover {
      opacity: 1;
    }
  }

  &:hover .copy-icon {
    display: block;
    opacity: 0.2;
  }
`;

export const OldConvoContainer = styled.div`
  overflow-y: auto;
  width: -webkit-fill-available;
  width: -moz-available;
  height: 100%;
  flex: 1 1;
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ada89a;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 6px;
  }

  // ::-webkit-scrollbar {
  //   width: 12px;
  // }

  // ::-webkit-scrollbar-track {
  //   -webkit-box-shadow: inset 0 0 6px rgb(71, 207, 222);
  //   border-radius: 10px;
  // }

  // ::-webkit-scrollbar-thumb {
  //   border-radius: 10px;
  //   -webkit-box-shadow: inset 0 0 6px rgb(67, 214, 72);
  // }

  // scrollbar-width: thin;
  // scrollbar-color: #ada89a transparent;
`;

function ComparePDF() {
  const [showSidebar, setShowSidebar] = useState(true);
  const [pdfOne, setPdfOne] = useState("");
  const [pdfTwo, setPdfTwo] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [compareResult, setCompareResult] = useState(null);
  const [comparePid, setComparePid] = useState(null);
  const [compareResultAll, setCompareResultAll] = useState([]);
  const userName = sessionStorage.getItem("userName");
  const [folderNames, setFolderNames] = useState([]);
  const [openShareDialog, setOpenShareDialog] = useState(false);
  const [shareUserName, setShareUserName] = useState("");
  const [dialogBtnLoading, setDialogBtnLoading] = useState(false);

  const [languageModel, setLanguageModel] = useState({
    title: "GPT-4 Turbo Preview (Open AI)",
    value: "gpt-4-0125-preview",
  });

  const notify = () => toast.error("Something went wrong!");


  const uplodFile = async () => {
    try {
      setShowSpinner(true);

      for (let i = 0; i < folderNames.length; i++) {
        if (projectName === folderNames[i]) {
          const notify = () =>
          toast.error("Project with same name already exists.");
          notify();
          setShowSpinner(false);
          return;
        }
      }

      const backendUrl = `${server_path}:5508/generate-presigned-url`;
      let files = [pdfOne, pdfTwo];
      let uploadFailed = false;
      console.log(files, "files");
      for (const file of files) {
        let requestBody = {
          fileName: file.name,
          projectName: projectName,
          userName: userName,
        };
        const options1 = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
          redirect: "follow",
        };
        const response = await fetch(backendUrl, options1);
        const data = await response.json();
        const signedUrl = data.url;

        const options = {
          method: "PUT",
          headers: {
            "Content-Type": "application/pdf",
            // "Content-Disposition": `attachment; filename="${file.name}"`,
          },
          body: file,
        };

        const uploadResponse = await fetch(signedUrl, options);
        if (!uploadResponse.ok) {
          uploadFailed = true; // Mark upload as failed
          break; // Exit loop if any upload fails
        }
      }
      if (!uploadFailed) {
        let requestBody = {
          project_name: projectName,
        };

        let response = await InvokePostServiceCall(
          `:5508/public_doc`,
          requestBody
        );
        let result = await response.text();
        console.log(result);
        handleCompare();
      }
    } catch (error) {
      notify();
      console.log(error, "Error Message");
    }
  };

  const getHistory = () => {
    let requestBody = {
      user_name: sessionStorage.getItem("userName"),
    };
    InvokePostServiceCall(`:5508/show_history`, requestBody)
      .then((response) => response.text())
      .then((result) => {
        let historyDetails = JSON.parse(result);
        let tempArr = [];

        historyDetails.forEach((item) => {
          let projectAlreadyAdded = false;
          let projectIndex = "";

          let finalDataObject = {
            images: [],
            tables: null,
            result: item.comparison,
            references: null,
          };
          for (let i = 0; i < tempArr.length; i++) {
            if (item.project_name === tempArr[i].project_name) {
              projectAlreadyAdded = true;
              projectIndex = i;
              break;
            }
          }
          if (projectAlreadyAdded) {
            tempArr[projectIndex].pid = item.project_name;
            tempArr[projectIndex].chatList.push({
              executed_at: item.created_at,
              question: item.project_name,
              response: finalDataObject,
            });
          } else {
            tempArr.push({
              chatList: [
                {
                  executed_at: item.created_at,
                  question: item.project_name,
                  response: finalDataObject,
                },
              ],
              pdfName: `${item.pdf1}, ${item.pdf2}`,
              name: item.project_name,
              pid: item.project_name,
              project_name: item.project_name,
            });
          }
          setCompareResultAll(tempArr);
        });
      })
      .catch((error) => {
        notify();
        console.log(error);
      });
  };

  const getFolderNames = async () => {
    try {
      let response = await InvokeGetServiceCall(":5508/get_folder_name");
      let result = await response.json();
      setFolderNames(result?.projects);
    } catch (error) {
      notify();
      console.log(error, "getFolderNames Error message");
    }
  };

  const handleCloseShareDialog = () => {
    setOpenShareDialog(false);
    setDialogBtnLoading(false);
    setShareUserName("");
  };

  const handleShare = async () => {
    try {
      setDialogBtnLoading(true);
      let requestBody = {
        shared_by: sessionStorage.getItem("userName"),
        project_name: projectName,
        shared_to: shareUserName,
      };
      let response = await InvokePostServiceCall(
        ":5508/save_project_access",
        requestBody
      );
      let result = await response.json();
      const notify = () => toast.success("Shared Successfully!");
      notify();
      handleCloseShareDialog();
    } catch (error) {
      console.log(error, "handleShare Error Message");
      handleCloseShareDialog();
      notify();
    }
  };

  useEffect(() => {
    getFolderNames();
    getHistory();
  }, []);

  const setAllChatHistory = (newChat = null) => {
    let allChats = [];
    allChats = [...compareResultAll];

    if (newChat !== null) {
      allChats.push({
        pdfName: newChat.pdfName,
        name: newChat.project_name,
        pid: newChat.project_name,
        project_name: newChat.project_name,
        chatList: [
          {
            executed_at: newChat.created_at,
            question: newChat.project_name,
            response: newChat.chatList[0].response,
          },
        ],
      });
      setCompareResultAll(allChats);
    } else {
      setComparePid(null);
      setCompareResult(null);
    }
  };

  const setPreviousChat = (prevChat) => {
    let currChat = [];
    let currPid = null;
    let allChats = [];
    let index = -1;

    currChat = compareResult;
    currPid = comparePid;
    allChats = [...compareResultAll];

    if (currChat) {
      index = allChats.findIndex((chatlist) => {
        return chatlist.pid === currPid;
      });
    }

    if (index !== -1) {
      allChats[index].chatList[0].response.result = compareResult.response;
      allChats[index].reportList = [];
    }

    setCompareResultAll(allChats);

    setComparePid(prevChat.pid);
    setCompareResult({
      name: prevChat.pdfName,
      response: marked(prevChat.chatList[0]?.response?.result),
    });
  };

  const handleCompare = async () => {
    try {
      const requestBody = {
        folder_name: projectName,
        created_by: userName,
        model_name: languageModel.value,
      };

      let response = await InvokePostServiceCall(
        ":5508/compare_pdfs",
        requestBody
      );
      setShowSpinner(false);
      if (!response.ok || !response.body) {
        throw response.statusText;
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let tempData = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) {
          // setLoading(false);
          break;
        }
        let decodedChunk = decoder.decode(value, { stream: true });

        tempData += decodedChunk;

        setCompareResult({
          name: `${pdfOne.name},${pdfTwo.name}`,
          response: marked(tempData),
        });
      }

      let finalDataObject = {
        images: [],
        tables: null,
        result: tempData,
        references: null,
      };

      setAllChatHistory({
        chatList: [
          {
            executed_at: "",
            question: projectName,
            response: finalDataObject,
          },
        ],
        pdfName: `${pdfOne.name},${pdfTwo.name}`,
        name: projectName,
        pid: projectName,
        project_name: projectName,
      });
    } catch (error) {
      notify();
      console.log(error);
    }
  };

  const handleDelete = async (projectName) => {
    try {
      setShowSpinner(true);
      let requestBody = {
        project_name: projectName,
      };
      let response = await InvokePostServiceCall(":5508/delete", requestBody);
      let result = await response.text();
      // let res = JSON.parse(result);
      // if (res.status === "Entry Deleted successfully") {
      let allchat = [...compareResultAll];
      const index = allchat.findIndex((item) => item.pid === projectName);
      if (index !== -1) {
        allchat.splice(index, 1);
        setCompareResultAll(allchat);
        if (comparePid === projectName) {
          setComparePid(null);
          setCompareResult(null);
        }
      }
      // }
      setShowSpinner(false);
    } catch (error) {
      setShowSpinner(false);
      notify();
      console.log("handleDelete Error Message", error);
    }
  };

  return (
    <div className="main-chat-container">
      <Header
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        languageModel={languageModel}
        setLanguageModel={setLanguageModel}
        showLanguageModels={false}
        isHistroyComp={true}
        showHomeButton={true}
      />
      {showSpinner && (
        <div className="custom-overlay">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      )}
      <ToastContainer />
      <div className="chat-history-container">
        {showSidebar && (
          <div className="prev-chat">
            <ChatHistory
              setAllChatHistory={setAllChatHistory}
              setPreviousChat={setPreviousChat}
              setProjectName={setProjectName}
              isUseModel={true}
              allChat={compareResultAll}
              isDisbaled={false}
              pid={comparePid}
              isEVR={true}
              deleteChat={handleDelete}
              showDeleteButton={true}
            ></ChatHistory>
          </div>
        )}
        <div
          className={`chat-history ${
            !showSidebar ? "w-100" : "chat-history-with-menu"
          } ${"h-100"}`}
        >
          <OldConvoContainer className="old-convo-container">
            <h3 style={{ marginLeft: "10px" }}>Compare</h3>
            {/* <span>PDF 1 :</span> */}
            {!compareResult && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "10px 10px 0px 10px",
                }}
              >
                <TextField
                  variant="outlined"
                  //   label="Project Name"
                  placeholder="Project Name"
                  size="small"
                  onChange={(e) => {
                    setProjectName(e.target.value);
                  }}
                />
                <input
                  type="file"
                  style={{
                    border: "2px solid #1976d2",
                    borderRadius: "5px",
                    padding: "3px",
                    marginLeft: "10px",
                  }}
                  onChange={(e) => {
                    // setSelectedFile(e.target.files[0]);
                    setPdfOne(e.target.files[0]);
                  }}
                />

                <input
                  type="file"
                  style={{
                    border: "2px solid #1976d2",
                    borderRadius: "5px",
                    padding: "3px",
                    marginLeft: "10px",
                  }}
                  onChange={(e) => {
                    // setSelectedFile(e.target.files[0]);
                    setPdfTwo(e.target.files[0]);
                  }}
                />

                <Autocomplete
                  disableClearable
                  value={languageModel}
                  defaultValue={languageModel}
                  onChange={(event, newValue) => {
                    setLanguageModel(newValue);
                  }}
                  size="small"
                  options={Language_Models}
                  getOptionLabel={(option) => option.title}
                  sx={{
                    width: "300px",
                    backgroundColor: "white",
                    borderRadius: "5px !important",
                    marginRight: "10px",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // variant="standard"
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "5px !important",
                      }}
                      // label="Language Model *"
                      placeholder="Language Model *"
                    />
                  )}
                />

                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#004987",
                    "&:hover": { backgroundColor: "#004987" },
                  }}
                  onClick={() => {
                    uplodFile();
                  }}
                  disabled={!pdfOne || !pdfTwo || !projectName}
                >
                  Compare
                </Button>
              </div>
            )}

            {compareResult?.name && (
              <ConvoDiv
                // key={index}
                className={`old-chat ${"h-auto"}`}
              >
                <div className="user-info" style={{ position: "relative" }}>
                  <div className="user-info-details">
                    <div className="w-100">
                      <strong>PDF 1:</strong>{" "}
                      <span>
                        <a
                          href={
                            compareResult?.name
                              .split(",")[0]
                              .includes("https://")
                              ? compareResult?.name.split(",")[0]
                              : `https://vs-knowledgebase-documents-habilis-dev.s3.amazonaws.com/compare-documents/${projectName}/${
                                  compareResult?.name.split(",")[0]
                                }`
                          }
                        >{` ${
                          compareResult?.name.split(",")[0].split("/")[
                            compareResult?.name.split(",")[0].split("/")
                              .length - 1
                          ]
                        }`}</a>
                      </span>
                    </div>
                    <div className="w-100">
                      <strong>PDF 2:</strong>{" "}
                      <span>
                        <a
                          href={
                            compareResult?.name
                              .split(",")[1]
                              .includes("https://")
                              ? compareResult?.name.split(",")[1]
                              : `https://vs-knowledgebase-documents-habilis-dev.s3.amazonaws.com/compare-documents/${projectName}/${
                                  compareResult?.name.split(",")[1]
                                }`
                          }
                        >{` ${
                          compareResult?.name.split(",")[1].split("/")[
                            compareResult?.name.split(",")[1].split("/")
                              .length - 1
                          ]
                        }`}</a>
                      </span>
                    </div>
                    <IconButton
                      sx={{ position: "absolute", right: "2px", top: "1px" }}
                      color="primary"
                      onClick={() => {
                        setOpenShareDialog(true);
                      }}
                    >
                      <ShareIcon />
                    </IconButton>
                  </div>
                </div>
                <Divider sx={{ border: "1px solid black", marginTop: "5px" }} />

                <div className="response-container evr-response-use-model ">
                  <div className="d-flex flex-column w-100">
                    <Markup content={compareResult?.response} />
                  </div>
                </div>
              </ConvoDiv>
            )}
          </OldConvoContainer>
        </div>
      </div>
      <Dialog
        open={openShareDialog}
        onClose={handleCloseShareDialog}
        fullWidth
        maxWidth="md"
      >
        <div style={styles.dialogContentDiv}>
          <Button
            variant="contained"
            color="warning"
            onClick={handleCloseShareDialog}
          >
            &#10005;
          </Button>
        </div>
        <DialogContent sx={{ paddingTop: "10px" }}>
          <TextField
            label="Project Name"
            type="text"
            inputProps={{ readOnly: true }}
            defaultValue={projectName}
            sx={{
              marginBottom: "24px",
              width: "40%",
            }}
          />
          <TextField
            label="Username"
            type="text"
            value={shareUserName}
            sx={{
              width: "100%",
            }}
            onChange={(e) => {
              setShareUserName(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions sx={styles.dialogActions}>
          <Button
            variant="contained"
            onClick={() => {
              handleShare();
            }}
            disabled={!shareUserName}
            sx={styles.saveBtn}
          >
            Share
            {dialogBtnLoading ? <Spinner size="sm" className="ml-2" /> : <></>}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ComparePDF;

const styles = {
  saveBtn: {
    height: "45px",
    backgroundColor: "#065f9b",
    "&:hover": {
      backgroundColor: "#065f9b",
      color: "white",
    },
  },
  dialogContentDiv: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "20px 20px 0px 0px",
  },
  dialogActions: {
    paddingRight: "20px",
    paddingBottom: "20px",
  },
};
